// extracted by mini-css-extract-plugin
module.exports = {"container":"_1-rQUz","wrapper":"_3QDSli","title":"_3w5xWX","subtitle":"_3DWDDn","message":"JJ25Nz","button":"_1hVMtT _3kgFjJ mz-button-default _2W7kc0 _3gMFZ8 _2lZtnH"};